<div class="container panel">
  <div class="form-field address-search-bar">
    <mat-form-field appearance="fill">
      <mat-label>{{('Modules.XPACManagementComponent.StoreInfoComponent.SearchAddress' | translate)}}</mat-label>
      <input matInput type="text" [formControl]="searchAddressControl" [matAutocomplete]="auto" (focus)="onFocus()" (blur)="onFocus()">
      <button class="button-class" *ngIf="searchText && isFocused" matSuffix mat-icon-button aria-label="Clear" (click)="emptyValue()">
        <mat-icon>highlight_off</mat-icon> 
      </button>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let item of selectLocationAutocompleteData$ | async  let last = last" [value]="item.address"
          (click)="getLocationDataByAddress(item.token)">
          {{item.address}}
          <mat-divider *ngIf="!last"></mat-divider>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>